interface State {
  isBusy: boolean;
}

export default {
  namespaced: true,
  state: {
    isBusy: false
  } as State,

  mutations: {
    updateIsBusy(state: State, payload: boolean) {
      state.isBusy = payload;
    }
  }
};
